export interface PaginationData {
  itemsPerPage: number;
  currentPage: number;
  totalItems: number;
}

export const defalutPaginationData = () => {
  return {
    itemsPerPage: 14,
    currentPage: 1,
    totalItems: 0
  };
};
